
import React from 'react';
import { motion } from 'framer-motion';
import { CloudMoon, Stars, Moon } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

export function BackgroundElements() {
  const isMobile = useIsMobile();
  
  return (
    <div className="absolute top-0 right-0 w-full h-full">
      <div className="absolute top-0 right-0 w-2/3 h-2/3 bg-blue-100/30 rounded-bl-[200px] opacity-60" />
      <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-blue-100/20 rounded-tr-[100px]" />
      
      {/* Animated sleep elements */}
      <motion.div 
        className={`absolute ${isMobile ? 'right-8 top-10' : 'right-20 top-20'}`}
        animate={{ 
          y: [0, -10, 0],
          rotate: [0, 5, 0]
        }}
        transition={{ 
          repeat: Infinity, 
          duration: 6,
          ease: "easeInOut" 
        }}
      >
        <CloudMoon className={`${isMobile ? 'h-10 w-10' : 'h-16 w-16'} text-indigo-300/70`} />
      </motion.div>
      
      <motion.div 
        className={`absolute ${isMobile ? 'right-36 top-24' : 'right-60 top-36'}`}
        animate={{ 
          y: [0, 8, 0],
          opacity: [0.5, 0.8, 0.5]
        }}
        transition={{ 
          repeat: Infinity, 
          duration: 5,
          ease: "easeInOut",
          delay: 1.5
        }}
      >
        <Stars className={`${isMobile ? 'h-6 w-6' : 'h-10 w-10'} text-indigo-400/60`} />
      </motion.div>
      
      <motion.div 
        className={`absolute ${isMobile ? 'left-8 bottom-24' : 'left-20 bottom-40'}`}
        animate={{ 
          y: [0, -5, 0],
          opacity: [0.6, 1, 0.6],
          scale: [1, 1.1, 1]
        }}
        transition={{ 
          repeat: Infinity, 
          duration: 4,
          ease: "easeInOut",
          delay: 0.8
        }}
      >
        <Moon className={`${isMobile ? 'h-8 w-8' : 'h-12 w-12'} text-indigo-500/60`} />
      </motion.div>
    </div>
  );
}
